import { render, staticRenderFns } from "./EmptyState.vue?vue&type=template&id=4223aec6"
import script from "./EmptyState.vue?vue&type=script&setup=true&lang=ts"
export * from "./EmptyState.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports